export const systemAccountCollection = "systemRequirementAccount";
export const carModelCollection = "carModel";
export const superPathCollection = "superPath";
export const timeSlotCollection = "timeSlot";
export const adScheduleCollection = "adSchedule";
export const routeAveragesCollection = "routeAverages";
export const audioFilesTrashCollection = "audioFilesTrash";
export const adCardCollection = "adCard";
export const adCardSetupCollection = "adCardSetup";
export const adAudioCollection = "adAudio";
export const businessCollection = "business";
export const transactionCollection = "transaction";
export const controllerCollection = "controller";
export const userCollection = "users";
export const systemUserCollection = "systemUser";
export const adCardTriggerCollection = "adCardTrigger";
// /systemRequirementAccount
